// Stringer spezifische Types

export type StringSize = 4 | 5 | 6 | 8;

export const stringImages: Record<StringSize, string> = {
  4: "../../../images/stringer/stringer_Image_4.png",
  5: "../../images/stringer/stringer_Image_5.png",
  6: "../../images/stringer/stringer_Image_6.png",
  8: "../../images/stringer/stringer_Image_8.png",
};

export type DefectType =
  | "Zellbruch"
  | "Ribbon-Shiftt"
  | "Schlechte Lötung"
  | "Zellabstand"
  | "Verschmutzung"
  | "Peeltest";

export const initialDefects: DefectType[] = [
  "Zellbruch",
  "Ribbon-Shiftt",
  "Schlechte Lötung",
  "Zellabstand",
  "Verschmutzung",
  "Peeltest",
];

// ---------------------------------
// Cellyield Interfaces
// ---------------------------------

export interface CellyieldRequest {
  defectTypeId: number;
  stationId: number;
  stringType: StringSize;
}

export interface CellyieldDeleteParams {
  defectTypeId: number;
  stationId: number;
  stringType: StringSize;
}

export interface CellyieldResponse {
  bool: boolean;
}

export interface CellyieldData {
  id: number;
  defectTypeId: number;
  stationId: number;
  creationDate: string;
  stringType: StringSize;
  defectType: null;
  station: null;
}
